<template>
  <div>
    <el-popover
      placement="bottom"
      width="394"
      height="326"
      trigger="click">
      <el-carousel height="230px">
        111
        <el-carousel-item v-for="item in 4" :key="item">
          <h3 class="small">{{ item }}</h3>
        </el-carousel-item>
      </el-carousel>
      <slot name="reference-div">
        <div slot="reference"></div>
      </slot>
    </el-popover>
  </div>
</template>

<script>
export default {
  name: 'PCPopoverInfo'
}
</script>

<style scoped>

</style>
